<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="overtimeStatisticsData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="[
              'operationKpiConfigurationManagement:overtimeManagement:delete'
            ]"
            @click="overtimeStatisticsDelmodal = true"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除 -->
    <Modal
      v-model="overtimeStatisticsDelmodal"
      width="360"
      :mask-closable="false"
    >
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{
            $t("alarms.common.sureDelete") +
              userName +
              $t("ticket.comment.what")
          }}
          ?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeOvertimeStatistics()"
          >{{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="overtimeStatisticsEditModal"
      :title="$t('MCM.extraContributionManagement.editExtraContribution')"
      :loading="loading"
      @on-ok="overtimeStatisticsSubmit('overtimeStatisticsEditForm')"
      @on-cancel="overtimeStatisticsReset('overtimeStatisticsEditForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="overtimeStatisticsEditForm"
        :model="overtimeStatisticsEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 姓名 -->
        <FormItem
          :label="$t('MCM.extraContributionManagement.name')"
          prop="name"
        >
          <Select
            v-model="overtimeStatisticsEditForm.name"
            style="width:300px;"
          >
            <Option
              :value="item.id"
              v-for="item in nameList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 额外贡献年月 -->
        <FormItem
          :label="$t('MCM.extraContributionManagement.extraContributionDate')"
          prop="overtimeYearMonth"
        >
          <DatePicker
            type="month"
            :placeholder="
              $t(
                'MCM.extraContributionManagement.pleaseSelectExtraContributionDate'
              )
            "
            style="width:300px;"
            @on-change="overtimeStatisticsEditForm.overtimeYearMonth = $event"
            :value="overtimeStatisticsEditForm.overtimeYearMonth"
            format="yyyy-MM"
          ></DatePicker>
        </FormItem>
        <!-- 额外贡献时间 -->
        <FormItem
          :label="$t('MCM.extraContributionManagement.extraContributionTime')"
          prop="overTime"
        >
          <InputNumber
            :min="0"
            v-model="overtimeStatisticsEditForm.overTime"
            style="width:120px;"
            :placeholder="
              $t(
                'MCM.extraContributionManagement.pleaseEnterExtraContributionTime'
              )
            "
          ></InputNumber>
          {{ $t("configuration_management.schedules.hour") }}
        </FormItem>
        <!-- 描述 -->
        <FormItem
          :label="$t('MCM.extraContributionManagement.description')"
          prop="remark"
        >
          <Input
            v-model="overtimeStatisticsEditForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import utils from "../../../../utils/utils.js";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

var tableOvertimeStatisticsVue = {};
export default {
  name: "TableOvertimeStatistics",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      overtimeStatisticsDelmodal: false,
      overtimeStatisticsEditModal: false,
      userName: "",
      name: "",
      startDate: "",
      modal_loading: false,
      loading: true,
      nameList: [],
      overtimeStatisticsEditForm: {
        name: "",
        overtimeYearMonth: "",
        overTime: 0,
        remark: ""
      },
      columns: [
        {
          title: this.$t("MCM.extraContributionManagement.name"),
          key: "userName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.overtimeStatisticsEditModal = true; //编辑弹出层
                    this.overtimeStatisticsEditForm.id = params.row.id;
                    // 姓名
                    this.$api.user.getOperationUsers({}).then(res => {
                      this.nameList = res.data;
                    });
                    this.overtimeStatisticsEditForm.name = params.row.userId;
                    // 额外贡献年月
                    this.overtimeStatisticsEditForm.overtimeYearMonth =
                      params.row.overtimeYearMonth;
                    // 额外贡献时间
                    this.overtimeStatisticsEditForm.overTime =
                      params.row.overTime;

                    // 备注
                    this.overtimeStatisticsEditForm.remark = params.row.remark;
                  }
                }
              },
              params.row.userName
            );
          }
        },
        {
          title: this.$t(
            "MCM.extraContributionManagement.extraContributionDate"
          ),
          key: "overtimeYearMonth"
        },
        {
          title: this.$t(
            "MCM.extraContributionManagement.extraContributionTime"
          ),
          key: "overTime"
        },
        {
          title: this.$t("MCM.extraContributionManagement.description"),
          key: "remark"
        },
        {
          title: this.$t("MCM.extraContributionManagement.operation"),
          slot: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.overtimeStatisticsDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "operationKpiConfigurationManagement:overtimeManagement:delete"
                      )
                    }
                  ]
                },
                this.$t("common.del")
              )
            ]);
          }
        }
      ],
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t(
              "MCM.extraContributionManagement.PleaseSelectName"
            ),
            trigger: "change",
            type: "number"
          }
        ],
        overtimeYearMonth: [
          {
            required: true,
            message: this.$t(
              "MCM.extraContributionManagement.pleaseSelectExtraContributionDate"
            )
          }
        ],
        remark: [
          {
            required: false,
            message: this.$t(
              "MCM.extraContributionManagement.pleaseEnterDescription"
            ),
            trigger: "blur"
          },
          {
            type: "string",
            max: 10000,
            message: this.$t(
              "MCM.extraContributionManagement.EnterMaximumOfCharacters"
            ),
            trigger: "blur"
          }
        ],
        overTime: [
          {
            required: true,
            message: this.$t(
              "MCM.extraContributionManagement.pleaseEnterExtraContributionTime"
            )
          }
        ]
      },
      overtimeStatisticsData: []
    };
  },
  beforeCreate: function() {
    tableOvertimeStatisticsVue = this;
  },
  mounted: function() {
    tableOvertimeStatisticsVue.getOvertimeStatisticsData();
  },
  methods: {
    showAll: function() {
      tableOvertimeStatisticsVue.getOvertimeStatisticsData();
    },
    // 分页显示数据
    getOvertimeStatisticsData: function() {
      eventBus.$on("name", function(name) {
        tableOvertimeStatisticsVue.name = name;
      });
      eventBus.$on("startDate", function(startDate) {
        tableOvertimeStatisticsVue.startDate = startDate;
      });
      // 列表分页
      this.$api.kpiOvertimeRecordByUser
        .pageKpiOvertimeRecordByUser({
          userName: tableOvertimeStatisticsVue.name,
          overtimeYearMonth: tableOvertimeStatisticsVue.startDate,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.overtimeStatisticsData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableOvertimeStatisticsVue.getOvertimeStatisticsData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableOvertimeStatisticsVue.getOvertimeStatisticsData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("name");
      eventBus.$off("startDate");
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
      this.userName = this.overtimeStatisticsData[index].userName;
    },
    removeOvertimeStatistics: function() {
      var lineIndex = this.lineIndex;
      // 删除
      this.$api.kpiOvertimeRecordByUser
        .deleteKpiOvertimeRecordByUser(
          "id",
          this.overtimeStatisticsData[lineIndex].id
        )
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableOvertimeStatisticsVue.getOvertimeStatisticsData();
            this.modal_loading = false;
            this.overtimeStatisticsDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 确定
    overtimeStatisticsSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.kpiOvertimeRecordByUser
            .checkKpiOvertimeRecordByUser({
              userId: this.overtimeStatisticsEditForm.name,
              overtimeYearMonth: this.overtimeStatisticsEditForm
                .overtimeYearMonth
            })
            .then(res => {
              if (res.status == 200) {
                this.$api.kpiOvertimeRecordByUser
                  .insertOrUpdate({
                    id: this.overtimeStatisticsEditForm.id,
                    userId: this.overtimeStatisticsEditForm.name,
                    overTime: this.overtimeStatisticsEditForm.overTime,
                    overtimeYearMonth: this.overtimeStatisticsEditForm
                      .overtimeYearMonth,
                    remark: this.overtimeStatisticsEditForm.remark
                  })
                  .then(res => {
                    setTimeout(() => {
                      tableOvertimeStatisticsVue.showAll();
                      this.$refs[name].resetFields();
                      this.loading = false;
                      this.$nextTick(() => {
                        this.loading = true;
                      });
                      this.$Message.success(this.$t("common.editSuccess"));
                      this.overtimeStatisticsEditModal = false;
                    }, 1000);
                  });
              }
            })
            .catch(err => {
              if (err.status == 400) {
                this.loading = false;
                setTimeout(() => {
                  this.loading = true;
                }, 0);
                this.$Modal.error({
                  title: this.$t("common.systemPrompt"),
                  content: this.$t("MCM.msg.contributionRepeat")
                });
              }
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    // 取消
    overtimeStatisticsReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/overtime_management/TableOvertimeStatistics.vue